module.exports = __webpack_public_path__ + "img/synthesize.2234bed4.svg";